"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanningDatesObject$ = exports.PlanningDatesObject$outboundSchema = exports.PlanningDatesObject$inboundSchema = void 0;
exports.planningDatesObjectToJSON = planningDatesObjectToJSON;
exports.planningDatesObjectFromJSON = planningDatesObjectFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
/** @internal */
exports.PlanningDatesObject$inboundSchema = z.object({
    actual_committee_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    agreed_extension_to_statutory_determination_deadline: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    application_received_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    application_validated_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    decision_issued_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    decision_made_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    decision_printed_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    last_advertised_in_press_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    last_site_notice_posted_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    latest_advertisement_expiry_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    latest_neighbour_consultation_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    latest_site_notice_expiry_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    latest_statutory_consultee_consultation_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    neighbour_comments_should_be_submitted_by_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    overall_consultation_expiry_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    permission_expiry_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    statutory_consultee_consultation_expiry_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    target_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "actual_committee_date": "actualCommitteeDate",
        "agreed_extension_to_statutory_determination_deadline": "agreedExtensionToStatutoryDeterminationDeadline",
        "application_received_date": "applicationReceivedDate",
        "application_validated_date": "applicationValidatedDate",
        "decision_issued_date": "decisionIssuedDate",
        "decision_made_date": "decisionMadeDate",
        "decision_printed_date": "decisionPrintedDate",
        "last_advertised_in_press_date": "lastAdvertisedInPressDate",
        "last_site_notice_posted_date": "lastSiteNoticePostedDate",
        "latest_advertisement_expiry_date": "latestAdvertisementExpiryDate",
        "latest_neighbour_consultation_date": "latestNeighbourConsultationDate",
        "latest_site_notice_expiry_date": "latestSiteNoticeExpiryDate",
        "latest_statutory_consultee_consultation_date": "latestStatutoryConsulteeConsultationDate",
        "neighbour_comments_should_be_submitted_by_date": "neighbourCommentsShouldBeSubmittedByDate",
        "overall_consultation_expiry_date": "overallConsultationExpiryDate",
        "permission_expiry_date": "permissionExpiryDate",
        "statutory_consultee_consultation_expiry_date": "statutoryConsulteeConsultationExpiryDate",
        "target_date": "targetDate",
    });
});
/** @internal */
exports.PlanningDatesObject$outboundSchema = z.object({
    actualCommitteeDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    agreedExtensionToStatutoryDeterminationDeadline: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    applicationReceivedDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    applicationValidatedDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    decisionIssuedDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    decisionMadeDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    decisionPrintedDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    lastAdvertisedInPressDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    lastSiteNoticePostedDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    latestAdvertisementExpiryDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    latestNeighbourConsultationDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    latestSiteNoticeExpiryDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    latestStatutoryConsulteeConsultationDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    neighbourCommentsShouldBeSubmittedByDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    overallConsultationExpiryDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    permissionExpiryDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    statutoryConsulteeConsultationExpiryDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    targetDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        actualCommitteeDate: "actual_committee_date",
        agreedExtensionToStatutoryDeterminationDeadline: "agreed_extension_to_statutory_determination_deadline",
        applicationReceivedDate: "application_received_date",
        applicationValidatedDate: "application_validated_date",
        decisionIssuedDate: "decision_issued_date",
        decisionMadeDate: "decision_made_date",
        decisionPrintedDate: "decision_printed_date",
        lastAdvertisedInPressDate: "last_advertised_in_press_date",
        lastSiteNoticePostedDate: "last_site_notice_posted_date",
        latestAdvertisementExpiryDate: "latest_advertisement_expiry_date",
        latestNeighbourConsultationDate: "latest_neighbour_consultation_date",
        latestSiteNoticeExpiryDate: "latest_site_notice_expiry_date",
        latestStatutoryConsulteeConsultationDate: "latest_statutory_consultee_consultation_date",
        neighbourCommentsShouldBeSubmittedByDate: "neighbour_comments_should_be_submitted_by_date",
        overallConsultationExpiryDate: "overall_consultation_expiry_date",
        permissionExpiryDate: "permission_expiry_date",
        statutoryConsulteeConsultationExpiryDate: "statutory_consultee_consultation_expiry_date",
        targetDate: "target_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PlanningDatesObject$;
(function (PlanningDatesObject$) {
    /** @deprecated use `PlanningDatesObject$inboundSchema` instead. */
    PlanningDatesObject$.inboundSchema = exports.PlanningDatesObject$inboundSchema;
    /** @deprecated use `PlanningDatesObject$outboundSchema` instead. */
    PlanningDatesObject$.outboundSchema = exports.PlanningDatesObject$outboundSchema;
})(PlanningDatesObject$ || (exports.PlanningDatesObject$ = PlanningDatesObject$ = {}));
function planningDatesObjectToJSON(planningDatesObject) {
    return JSON.stringify(exports.PlanningDatesObject$outboundSchema.parse(planningDatesObject));
}
function planningDatesObjectFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PlanningDatesObject$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PlanningDatesObject' from JSON`);
}
//# sourceMappingURL=planningdatesobject.js.map